import React from 'react';

import { RequestAzureDevOps } from '../RequestAzureDevOps';

import {
  ContentBlock,
  CostValue,
  Description,
  RightSection,
  RightSectionColumn,
  SectionWrapper,
  Title,
} from '../../EnvironmentSetup/EnvironmentSetup.styles';
import { ApButtonLink } from '@alixpartners/ui-components';
import { generateEnvETSMail } from '../../../../utils/mailTo';

interface IAzureDevOpsSectionProps {
  isAdoEnabled?: boolean;
  azureDevOpsProjectUrl: string;
  azureDevOpsRepoUrl: string;
  projectCodeName: string;
  userName: string;
}

export const AzureDevOpsSection = ({
  isAdoEnabled,
  azureDevOpsProjectUrl,
  azureDevOpsRepoUrl,
  projectCodeName,
  userName,
}: IAzureDevOpsSectionProps) => {
  if (!isAdoEnabled) {
    return (
      <RequestAzureDevOps
        requestUrl={generateEnvETSMail(
          'Azure DevOps',
          projectCodeName || '',
          userName || ''
        )}
        animationIndex={1}
        label="Azure DevOps"
        description="Not configured for this environment"
      />
    );
  }

  return (
    <SectionWrapper animationIndex={1}>
      <Title>Azure DevOps</Title>
      <ContentBlock>
        <Description>Configured</Description>
        <RightSection>
          <RightSectionColumn>
            <CostValue>
              <ApButtonLink
                target="_blank"
                href={azureDevOpsProjectUrl}
                rel="noopener noreferrer"
              >
                Project URL
              </ApButtonLink>
            </CostValue>
          </RightSectionColumn>
          <RightSectionColumn>
            <CostValue>
              <ApButtonLink
                target="_blank"
                href={azureDevOpsRepoUrl}
                rel="noopener noreferrer"
              >
                Repo URL
              </ApButtonLink>
            </CostValue>
          </RightSectionColumn>
          <RightSectionColumn />
        </RightSection>
      </ContentBlock>
    </SectionWrapper>
  );
};
